// extracted by mini-css-extract-plugin
var _1 = "Image-moduleimage__G5DjE";
export { _1 as "image" }
